import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { TitleComponent } from './title/title.component';

import { MessageService } from 'primeng/api';
import { SidebarModule } from 'primeng/sidebar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PanelMenuModule } from 'primeng/panelmenu';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule as inlineCalendar } from 'primeng/calendar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TherapistHeaderComponent } from './header/therapist-header/therapist-header.component';
import { ProfileComponent } from './profile/profile.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { InformationDialogComponent } from 'src/app/shared/components/information-dialog/information-dialog.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SidebarComponent } from './sidebar/SidebarComponent';
import { HeaderComponent } from 'src/app/shared/header/header.component';
import { FooterComponent } from 'src/app/shared/footer/footer.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { NotificationViewAllComponent } from './notification/notification.component';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputMaskModule } from 'primeng/inputmask';
import { PatientHeaderComponent } from './patient-header/patient-header.component';
import { PatientFooterComponent } from './patient-footer/patient-footer.component';
import { BookAppoinmentDialogComponent } from 'src/app/shared/components/book-appoinment-dialog/book-appoinment-dialog.component';
import { SupportRequestComponent } from './support-request/support-request.component';
import { SupportComponent } from './support/support.component';
import { PageUnauthorizedComponent } from './page-unauthorized/page-unauthorized.component';
import { AudioPlayerComponent } from './audio-player/audio-player.component';
import { RadioButtonModule } from 'primeng/radiobutton';

import { GoogleMapsModule } from '@angular/google-maps';
import { TooltipModule } from 'primeng/tooltip';
import { PhonePipe } from 'src/app/pipes/usnumberformat.pipe';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { FilterPipe } from '../pipes/FilterPipe';
import { MobileDetectionService } from './services/mobiledetection.service';
import { EmailLogsComponent } from './email-logs/email-logs.component';
import { SmsLogsComponent } from './sms-logs/sms-logs.component';

import { UpdateStatusOfAppointmentComponent } from './components/update-status-of-appointment/update-status-of-appointment.component';
import { UpdateStatusOfAppointmentsComponent } from './components/update-status-of-appointments/update-status-of-appointments.component';

import { InputSwitchModule } from 'primeng/inputswitch';

import { OverrideMergeDialogComponent } from 'src/app/shared/components/override-merge-dialog/override-merge-dialog.component';
import { LegendsInfoComponent } from './legends-info/legends-info.component';
import { PipesModule } from '../pipes/pipes/pipes.module';
import { PasswordModule } from 'primeng/password';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { SharedSetPasswordComponent } from './set-password/shared-set-password.component';
import { SelectModule } from 'primeng/select';
import { PopoverModule } from 'primeng/popover';
import { TabsModule } from 'primeng/tabs';
import { RouterModule } from '@angular/router';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { CollectPaymentComponent } from './collect-payment/collect-payment.component';
import { TimerPaymentComponent } from './collect-payment/timer-paymenet.component';
import { MapComponent } from './map/map.component';
import { WeekViewScheduler } from '../therapist/my-appointments/week-view-scheduler/week-view-scheduler-component';
import { PatientDetailSidebarComponent } from '../therapist/patient-detail-sidebar/patient-detail-sidebar.component';
@NgModule({
  declarations: [
    BookAppoinmentDialogComponent,
    PatientHeaderComponent,
    PatientFooterComponent,
    ConfirmDialogComponent,
    InformationDialogComponent,
    TherapistHeaderComponent,
    ProfileComponent,
    ChangePasswordComponent,
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    NotificationViewAllComponent,
    TitleComponent,
    SupportRequestComponent,
    SupportComponent,
    PageUnauthorizedComponent,
    AudioPlayerComponent,
    PhonePipe,
    FilterPipe,
    EmailLogsComponent,
    SmsLogsComponent,
    UpdateStatusOfAppointmentComponent,
    UpdateStatusOfAppointmentsComponent,
    OverrideMergeDialogComponent,
    LegendsInfoComponent,
    SharedSetPasswordComponent,
    PaymentHistoryComponent,
    CollectPaymentComponent,
    TimerPaymentComponent,
    MapComponent,
    PatientDetailSidebarComponent
    //WeekViewScheduler
  ],

  imports: [
    CommonModule,
    CheckboxModule,
    SidebarModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ToastModule,
    PanelMenuModule,
    DropdownModule,
    ScrollPanelModule,
    OverlayPanelModule,
    PopoverModule,
    inlineCalendar,
    ProgressSpinnerModule,
    DialogModule,
    DynamicDialogModule,
    MenuModule,
    MultiSelectModule,
    InputMaskModule,
    RadioButtonModule,
    GoogleMapsModule,
    TooltipModule,
    TabViewModule,
    InputSwitchModule,
    PipesModule,
    PasswordModule,
    SvgIconComponent,
    SelectModule,
    TabsModule
  ],
  providers: [CookieService, MessageService, MobileDetectionService],

  exports: [
    CheckboxModule,
    SidebarModule,
    ToastModule,
    PanelMenuModule,
    DropdownModule,
    ScrollPanelModule,
    OverlayPanelModule,
    PopoverModule,
    TherapistHeaderComponent,
    ProfileComponent,
    ChangePasswordComponent,
    PatientHeaderComponent,
    PatientFooterComponent,
    inlineCalendar,
    DialogModule,
    DynamicDialogModule,
    ProgressSpinnerModule,
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    GoogleMapsModule,
    MultiSelectModule,
    InputMaskModule,
    AudioPlayerComponent,
    InputMaskModule,
    RadioButtonModule,
    PhonePipe,
    TabViewModule,
    FilterPipe,
    EmailLogsComponent,
    SmsLogsComponent,
    InputSwitchModule,
    LegendsInfoComponent,
    PasswordModule,
    SvgIconComponent,
    SelectModule,
    TabsModule,

    PaymentHistoryComponent,
    CollectPaymentComponent,
    TimerPaymentComponent,
    MapComponent,
    PatientDetailSidebarComponent
  ]
})
export class SharedModule {}
